import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Button } from '@/components/button'
import * as HashInput from '@/components/hash-copy/index'
import { QuickReferenceIcon } from '@/components/icons/quick-reference'
import { useMediaQuery } from '@/hooks/use-media-query'
import api from '@/services/api'
import { decodeBase64ToBlob } from '@/utils/buffer-files'

interface ViewContract {
  contract_hash: string
  file: string
  file_type: string
}

export default function ViewContract() {
  const { idContract } = useParams()
  const [contractData, setContractData] = useState<ViewContract | null>(null)

  const isDesktop = useMediaQuery('(min-width: 768px)')

  useEffect(() => {
    api
      .get<ViewContract>(`/sponsorship/contract/view/${idContract}`)
      .then((response) => {
        const pdfURL = decodeBase64ToBlob(response.data.file)

        setContractData({
          ...response.data,
          file: pdfURL,
        })
      })
  }, [idContract])

  return (
    <div className="flex h-screen flex-col gap-8 bg-monochromatic-200 px-5 py-5 md:px-16 md:py-20 md:pb-20 md:pt-10 lg:gap-20 2xl:px-48">
      <div className="space-y-10">
        <div className="flex items-center gap-3">
          <QuickReferenceIcon className="size-6 text-monochromatic-300" />

          <h3 className="text-2xl font-bold text-bios-title">Contrato</h3>
        </div>

        <div>
          <HashInput.HashCardRoot>
            <HashInput.HashInputTitle>
              Hash do contrato registrado na blockchain
            </HashInput.HashInputTitle>
            <HashInput.HashInputControl
              label="Identificação do contrato registrado na blockchain"
              hashValue={contractData?.contract_hash}
            />
          </HashInput.HashCardRoot>
        </div>
      </div>

      {!isDesktop ? (
        <div className="flex h-full items-center justify-center">
          <a href={contractData?.file} target="_blank" rel="noreferrer">
            <Button>Visualizar PDF</Button>
          </a>
        </div>
      ) : (
        <div className="h-screen">
          <iframe className="h-full w-full" src={contractData?.file} />
        </div>
      )}
    </div>
  )
}
